
import {
  ChangeEvent,
  MouseEvent,
  ReactElement,
  useEffect,
  useState
} from 'react';
//import { BigNumber } from 'ethers';

import styled from 'styled-components';

import { Row, Col, Form, Button, ProgressBar } from 'react-bootstrap'



const StyledDeployContractButton = styled.button`
  width: 240px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledGreetingDiv = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 135px 2.7fr 1fr;
  grid-gap: 10px;
  place-self: center;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-weight: bold;
`;

const StyledInput = styled.input`
  padding: 0.4rem 0.6rem;
  line-height: 2fr;
`;

const StyledButton = styled.button`
  width: 150px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;

export function ERC20GameTokenApp(): ReactElement {
  return (
    <StyledAppDiv>
      <ERC20GameTokenContract />
    </StyledAppDiv>
  );
}

export function ERC20GameTokenContract(): ReactElement {
   
  return (
    <>
      <div className="container-fluid">
      <div className="row">
        <main role="main" className="col-lg-12 mx-auto" style={{ maxWidth: '1000px' }}>
          <div className="content mx-auto">
          <Row className="g-4">
            <h6 className="p-4 text-center">
            Contract: 0xDF5Ba79F0FD70c6609666d5eD603710609a530AB
            </h6>
          </Row>
          <Row className="g-4">
            <h3 className="p-1 text-center">
            BUY $CFX v2 on Pancakeswap
            </h3>
            <h6 className="p-1 text-center">
            <a href="https://pancakeswap.finance/swap?inputCurrency=BNB&outputCurrency=0xDF5Ba79F0FD70c6609666d5eD603710609a530AB" target="_blank">https://pancakeswap.finance/swap?inputCurrency=BNB&outputCurrency=0xDF5Ba79F0FD70c6609666d5eD603710609a530AB</a>
            </h6>
            </Row>
          <Row className="g-4">
            <Col>
            </Col>
            <Col className="text-center" style={{ minWidth: '320px' }}>
            <img src='./images/CFXv2.png' className='img-fluid' alt='...' />
            </Col>
            <Col>
            </Col>
          </Row>
          <Row className="g-4">
            <h5 className="p-1 text-center">
              1 $CFX = MARKETPRICE
            </h5>
          </Row>
          <Row className="g-4">

            </Row>
            <Row className="g-4">
            <h5 className="p-4 text-center">
            Cosmic Force Token $CFX is used for in-game NFT purchases and rewards
            </h5>
            <h6 className="text-center">
            $CFX v2 Latest Chart HERE - <a href="https://dexscreener.com/bsc/0xba983bf3c1e87689237aac63b236e5e65e06a88e" target="_blank"> https://dexscreener.com/bsc/0xba983bf3c1e87689237aac63b236e5e65e06a88e</a>

            </h6>
            <h6 className="text-center">
            You can SWAP $CFX v1 HERE - <a href="https://dapp.cosmicforce.xyz/cfxswap" target="_blank">https://dapp.cosmicforce.xyz/cfxswap</a>
            </h6>
            </Row>
          </div>
        </main>
      </div>
    </div>
    </>
  );
}
